import React from 'react';

import DeleteGroup from 'components/Builder/DeleteGroup';
import EditGroup from 'components/Builder/EditGroup';

function GroupActions(props) {
	return (
		<div className="GroupAction">
			<div className="current-group-action">
				<DeleteGroup setFetchingGroup={props.setFetchingGroup} />
				<EditGroup setFetchingGroup={props.setFetchingGroup} />
			</div>
		</div>
	);
}

export default GroupActions;
